"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatExpiry = exports.formatCVV = exports.formatCreditCard = exports.COMPANY_ORDER_STATUS_OPTIONS = exports.GATEWAY_PROVIDER_OPTIONS = exports.formatNumber = exports.formatMoney = exports.formatDateTime = exports.MOMENT_DATE_TIME_FORMAT = exports.formatTime = exports.MOMENT_TIME_FORMAT = exports.formatDate = exports.MOMENT_DATE_FORMAT = void 0;
const moment_1 = __importDefault(require("moment"));
const currency_js_1 = __importDefault(require("currency.js"));
const db_1 = require("@milespay.co/db");
exports.MOMENT_DATE_FORMAT = 'DD/MM/YYYY';
const formatDate = (value) => {
    return (0, moment_1.default)(value).format(exports.MOMENT_DATE_FORMAT);
};
exports.formatDate = formatDate;
exports.MOMENT_TIME_FORMAT = 'HH:mm';
const formatTime = (value) => {
    return (0, moment_1.default)(value).format(exports.MOMENT_TIME_FORMAT);
};
exports.formatTime = formatTime;
exports.MOMENT_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
const formatDateTime = (value) => {
    return (0, moment_1.default)(value).format(exports.MOMENT_DATE_TIME_FORMAT);
};
exports.formatDateTime = formatDateTime;
const formatMoney = (value) => {
    return (0, currency_js_1.default)(value).format({
        symbol: "R$ ",
        decimal: ",",
        separator: ".",
    });
};
exports.formatMoney = formatMoney;
const formatNumber = (value) => {
    return Number(value).toLocaleString("pt-BR");
};
exports.formatNumber = formatNumber;
exports.GATEWAY_PROVIDER_OPTIONS = [
    { label: 'Pagar.me', value: db_1.GATEWAY_PROVIDER.PAGAR_ME },
    { label: 'Cielo', value: db_1.GATEWAY_PROVIDER.CIELO },
];
exports.COMPANY_ORDER_STATUS_OPTIONS = [
    { label: 'Pendente', value: db_1.COMPANY_ORDER_STATUS.PENDING, chipColor: 'info' },
    { label: 'Pago', value: db_1.COMPANY_ORDER_STATUS.PAID, chipColor: 'success' },
    { label: 'Cancelado', value: db_1.COMPANY_ORDER_STATUS.CANCELLED, chipColor: 'error' }
];
const formatCreditCard = (value) => {
    const cleanedValue = value.replace(/\D/g, '');
    if (cleanedValue.startsWith('37') || cleanedValue.startsWith('34')) {
        return cleanedValue
            .slice(0, 15)
            .replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
    }
    else {
        return cleanedValue
            .slice(0, 16)
            .replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
    }
};
exports.formatCreditCard = formatCreditCard;
const formatCVV = (value) => {
    return value.replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1');
};
exports.formatCVV = formatCVV;
const formatExpiry = (value) => {
    return value.replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\/\d{2})\d+?$/, '$1');
};
exports.formatExpiry = formatExpiry;
